import { IconSparkles } from 'featherico';
import type DeltaStatic from 'quill-delta';
import { useEffect, useState } from 'react';
import { WritingAssistantContext } from '../../../../types/WritingAssistant';
import ToolbarButton from '../../components/RichTextArea/Toolbar/button';
import SparkPosition from '../../components/Spark/SparkPosition';
import { trackEvent } from '../../services/Tracking';
import WritingAssistantModal from './lazy';
import styles from './style.m.less';

interface Props {
    getText: () => string;
    setText: (text: string) => DeltaStatic;
    context: WritingAssistantContext;
}

let sparkAlreadyShown = false;

export default function WritingAssistantToolbarButton({ getText, setText, context }: Props) {
    const [isOpen, setIsOpen] = useState(false);
    const [contentForPrompt, setContentForPrompt] = useState(getText() ?? '');
    const [showSpark, setShowSpark] = useState(false);

    const handleClick = () => {
        trackEvent({
            category: 'AI_WRITING_ASSISTANT',
            label: 'toolbar button',
            action: 'click',
        });
        setContentForPrompt(getText());
        setIsOpen(true);
    };
    const handleClose = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        if (!sparkAlreadyShown) {
            sparkAlreadyShown = true;
            setShowSpark(true);

            return () => {
                sparkAlreadyShown = false;
            };
        }
    }, []);

    return (
        <>
            {showSpark && (
                <SparkPosition x={-67} y={12.5} zIndex={2} story="AI_ASSISTANT" type="toolbarButton"></SparkPosition>
            )}
            <ToolbarButton onClick={handleClick} title="AI Writing Assistant" className={styles.button}>
                <IconSparkles /> AI
            </ToolbarButton>
            {isOpen && (
                <WritingAssistantModal
                    isOpen={isOpen}
                    onClose={handleClose}
                    content={contentForPrompt}
                    setText={setText}
                    context={context}
                />
            )}
        </>
    );
}
